import coin_hat_small from '../assets/home-v2/coin_hat_small.webp'
import coin_hat_big from '../assets/home-v2/coin_hat_big.webp'
import cherry_small from '../assets/home-v2/cherry_small.webp'
import cherry_big from '../assets/home-v2/cherry_big.webp'
import slot_small from '../assets/home-v2/slot_small.webp'
import slot_big from '../assets/home-v2/slot_big.webp'
import slot_coins_small from '../assets/home-v2/slot_coins_small.webp'
import slot_coins_big from '../assets/home-v2/slot_coins_big.webp'
import bell_small from '../assets/home-v2/bell_small.webp'
import bell_big from '../assets/home-v2/bell_big.webp'
import dice from '../assets/raffle/dice.webp'
import dice_pc from '../assets/raffle/dice_pc.webp'
import leperchaun from '../assets/raffle/leperchaun.webp'
import leperchaun_pc from '../assets/raffle/leperchaun_pc.webp'
import breaking_bad from '../assets/casino/breaking_bad.webp'
import breaking_bad_pc from '../assets/casino/breaking_bad_pc.webp'

export const IMAGE_SIZES = {
  'coin-hat': {
    small: coin_hat_small,
    big: coin_hat_big,
  },
  "cherry": {
    small: cherry_small,
    big: cherry_big,
  },
  "slot": {
    small: slot_small,
    big: slot_big,
  },
  'slot-coins': {
    small: slot_coins_small,
    big: slot_coins_big,
  },
  "bell": {
    small: bell_small,
    big: bell_big,
  },
  "dice": {
    small: dice,
    big: dice_pc,
  },
  "leperchaun": {
    small: leperchaun,
    big: leperchaun_pc,
  },
  "breaking-bad": {
    small: breaking_bad,
    big: breaking_bad_pc,
  },
}
